/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpdateNotebookInput {
  /**
  * New name for the notebook
  */
  'name'?: string;
  /**
  * New description for the notebook
  */
  'description'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "description",
      "baseName": "description",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateNotebookInput.attributeTypeMap;
  }

  public constructor() {
  }
}

